<!-- Buy.vue -->
<template>
	<div class="main-content" v-if="detailInfo.goods_attr">
    <flex-line :is-link="true" :show-border="true" @click.native="changeAttrState()">
    	<span>参数</span>
    </flex-line>
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import flexLine from '../../../flexLine'
export default {
  data () {
    return {}
  },
components:{flexLine},
  computed: {
    ...mapState({
      detailInfo: state => state.goodsdetail.detailInfo,
    }),
  },

  created () {},


  methods: {
    ...mapMutations({
      saveAttrState: 'saveAttrState'
    }),


    changeAttrState () {
      this.saveAttrState(true)
    },

  }
}
</script>

<style lang="scss" scoped>
	.main-content{padding:0 $pageSpace;background-color: #fff;}
</style>
